export default __webpack_public_path__ + "static/media/bridges.8d90385a.png";